export const skillGroups = [
  {
    id: "frontend",
    label: "Frontend",
    index: "01",
    items: [
      { id: "react", label: "React" },
      { id: "vue", label: "Vue 3" },
      { id: "nextjs", label: "Next.js" },
      { id: "javascript", label: "JavaScript" },
      { id: "htmlcss", label: "HTML / CSS" },
      { id: "tailwind", label: "Tailwind CSS" },
      { id: "framer", label: "Framer Motion" },
    ],
  },
  {
    id: "backend",
    label: "Backend & data",
    index: "02",
    items: [
      { id: "laravel", label: "Laravel" },
      { id: "supabase", label: "Supabase" },
      { id: "xano", label: "XANO" },
      { id: "sql", label: "SQL / MySQL" },
      { id: "rest", label: "REST APIs" },
      { id: "firebase", label: "Firebase" },
    ],
  },
  {
    id: "automation",
    label: "Automation & platforms",
    index: "03",
    items: [
      { id: "ghl", label: "GoHighLevel" },
      { id: "ai", label: "AI workflows" },
      { id: "crm", label: "CRM integrations" },
      { id: "lead", label: "Lead response systems" },
    ],
  },
  {
    id: "delivery",
    label: "Delivery",
    index: "04",
    items: [
      { id: "git", label: "Git" },
      { id: "vercel", label: "Vercel" },
      { id: "agile", label: "Agile" },
      { id: "lead-team", label: "Team leadership" },
      { id: "ops", label: "Operations" },
    ],
  },
  {
    id: "tools",
    label: "AI & dev tools",
    index: "05",
    items: [
      { id: "claude", label: "Claude" },
      { id: "chatgpt", label: "ChatGPT" },
      { id: "cursor", label: "Cursor" },
      { id: "vscode", label: "VS Code" },
      { id: "github", label: "GitHub" },
    ],
  },
];

export const featuredSkill = {
  id: "ai-growth",
  label: "Automation & AI growth systems",
  badge: "Differentiator",
  description:
    "End-to-end automation — AI-driven lead response, CRM workflows, and GoHighLevel integrations that replace repetitive handoffs with self-running pipelines.",
  link: "/real-estate-ai-growth-system",
  linkLabel: "See the AI Real Estate Growth System",
};
